import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* optOutEvent({ id, callbacks }) {
  try {
    const response = yield call(api.optOutEvent, id);
    yield put(Actions.optOutEventSuccess(response.data));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks?.success, response.data);
    }
  } catch (error) {
    yield put(Actions.optOutEventFail(error));
    if (typeof callbacks?.failure === 'function') {
      yield call(callbacks.failure, error);
    }
  }
}

function* watchOptOutEvent() {
  yield takeLatest(Actions.OPT_OUT_EVENT_REQUEST, optOutEvent);
}

export default function* optOut() {
  yield all([fork(watchOptOutEvent)]);
}
